import React  from "react";
import ClientTable from "./components/ClientTable";
import { connect } from "react-redux";

const Clients = () => {
	
	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">      		
	      	<ClientTable/>
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
  	  
});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(Clients);